import { type Ref, type ButtonHTMLAttributes } from "react";
import buttonStyleClasses, { type ButtonStyle } from "./buttonStyle";

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  dropdown?: boolean;
  buttonStyle?: ButtonStyle;
  ref?: Ref<HTMLButtonElement>;
}

export default function Button({
  children,
  buttonStyle = "primary",
  dropdown,
  ...props
}: Props) {
  return (
    <button {...props} className={buttonStyleClasses(buttonStyle, dropdown)}>
      {children}
    </button>
  );
}
